import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { queryStringParser } from '../../utils/queryStringParser';

import API from '../../services/api';
import Styling from '../../components/AuthStyling';

const EmailVerify = ({ location }) => {
  const [message, setMessage] = useState(undefined);

  useEffect(() => {
    async function emailVerify(userId, token) {
      API.emailVerify(userId, token)
        .then(() => {
          setMessage('Email Verified');
        })
        .catch(() => {
          setMessage('Email verificition failed. Please try again.');
        });
    }

    const setqueryParams = () => {
      const userId = queryStringParser(location.search, 'u');
      const token = queryStringParser(location.search, 't');
      emailVerify(userId, token);
    };
    setqueryParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return message ? <Styling message={message} /> : null;
};
EmailVerify.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
export default EmailVerify;
